import styled from 'styled-components';

export const UploadContainer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-self: center;
	align-items: center;
	justify-self: center;
	gap: 0.5rem;
`;
